import { render } from "./ModalAddStaffRolePriv.vue?vue&type=template&id=22c8b71f"
import script from "./ModalAddStaffRolePriv.vue?vue&type=script&lang=js"
export * from "./ModalAddStaffRolePriv.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__